import React from "react";
import PropTypes from "prop-types";

import { format } from "d3-format";
import { timeFormat } from "d3-time-format";

import {
  Modal,
  Button,
  FormGroup,
  ControlLabel,
  FormLabel,
  FormControl,
} from "react-bootstrap";
import { ema } from "react-stockcharts/lib/indicator";

import { ChartCanvas, Chart } from "react-stockcharts";
import {
  CandlestickSeries,
  BarSeries,
  MACDSeries,
} from "react-stockcharts/lib/series";
import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import {
  CrossHairCursor,
  EdgeIndicator,
  MouseCoordinateY,
  MouseCoordinateX,
  CurrentCoordinate,
} from "react-stockcharts/lib/coordinates";

import { discontinuousTimeScaleProvider } from "react-stockcharts/lib/scale";
import {
  OHLCTooltip,
  MACDTooltip,
  MovingAverageTooltip,
} from "react-stockcharts/lib/tooltip";
import { macd } from "react-stockcharts/lib/indicator";

import { fitWidth } from "react-stockcharts/lib/helper";
import {
  InteractiveText,
  DrawingObjectSelector,
} from "react-stockcharts/lib/interactive";
import { getMorePropsForChart } from "react-stockcharts/lib/interactive/utils";
import { head, last, toObject } from "react-stockcharts/lib/utils";
import { saveInteractiveNodes, getInteractiveNodes } from "./interactiveutils";
import {
  ScatterSeries,
  SquareMarker,
  TriangleMarker,
  CircleMarker,
  LineSeries,
} from "react-stockcharts/lib/series";

import dayjs from "dayjs";
import "./../../assets/css/Style.css";
import {
  Card,
  Table,
  InputGroup,
  Alert,
  Image,
  ButtonGroup,
  Form,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faList,
  faEdit,
  faTrash,
  faStepBackward,
  faFastBackward,
  faStepForward,
  faFastForward,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import MyToast from "../MyToast";
import axios from "axios";
import { timeParse } from "d3-time-format";
import { tsvParse, csvParse } from "d3-dsv";

class Dialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.text,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      text: nextProps.text,
    });
  }
  handleChange(e) {
    this.setState({
      text: e.target.value,
    });
  }
  handleSave() {
    this.props.onSave(this.state.text, this.props.chartId);
  }
  render() {
    const { showModal, onClose } = this.props;
    const { text } = this.state;

    return (
      <Modal show={showModal} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit text</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <FormGroup controlId="text">
              <FormLabel>Text</FormLabel>
              <FormControl
                type="text"
                value={text}
                onChange={this.handleChange}
              />
            </FormGroup>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
const macdAppearance = {
  stroke: {
    macd: "#FF0000",
    signal: "#00F300",
  },
  fill: {
    divergence: "#4682B4",
  },
};

class CandleStickChartWithText extends React.Component {
  constructor(props) {
    super(props);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onDrawComplete = this.onDrawComplete.bind(this);
    this.handleChoosePosition = this.handleChoosePosition.bind(this);

    this.saveInteractiveNodes = saveInteractiveNodes.bind(this);
    this.getInteractiveNodes = getInteractiveNodes.bind(this);

    this.handleSelection = this.handleSelection.bind(this);

    this.saveCanvasNode = this.saveCanvasNode.bind(this);

    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);

    this.state = {
    	API_URL: process.env.REACT_APP_API_ENDPOINT
          ? process.env.REACT_APP_API_ENDPOINT.replace(/\/+$/, "") + "/"
          : "",
      enableInteractiveObject: true,
      textList_1: [],
      textList_3: [],
      showModal: false,
      symbols: [
        { value: "NIFTY 50", display: "NIFTY" },
        { value: "NIFTY BANK", display: "BANK NIFTY" },
        { value: "NIFTY FIN SERVICE", display: "FINNIFTY" },
        { value: "SENSEX", display: "SENSEX" },
         { value: "BANKEX", display: "BANKEX" },
        { value: "NIFTY MID SELECT", display: "MIDCPNIFTY" },
      ],
      expiry: "",
      optionName: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.searchChange = this.searchChange.bind(this);
  }

  searchChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  searchData = () => {
    axios
      .get(
        this.state.API_URL +
          "api/optionData?symbol=" +
          this.state.search +
          "&expiry=" +
          this.state.expiry +
          "&optionName=" +
          this.state.optionName
      )
      .then((response) => csvParse(response.data))
      .then((data) => {
        this.setState({
          data: data,
          currentPage: 1,
        });
      })
      .catch((error) => {
        console.log(error);
        localStorage.removeItem("jwtToken");
        this.props.history.push("/");
      });
  };

  saveCanvasNode(node) {
    this.canvasNode = node;
  }
  handleSelection(interactives, moreProps, e) {
    if (this.state.enableInteractiveObject) {
      const independentCharts = moreProps.currentCharts.filter((d) => d !== 2);
      if (independentCharts.length > 0) {
        const first = head(independentCharts);

        const morePropsForChart = getMorePropsForChart(moreProps, first);
        const {
          mouseXY: [, mouseY],
          chartConfig: { yScale },
          xAccessor,
          currentItem,
        } = morePropsForChart;

        const position = [xAccessor(currentItem), yScale.invert(mouseY)];
        const newText = {
          ...InteractiveText.defaultProps.defaultText,
          position,
        };
        this.handleChoosePosition(newText, morePropsForChart, e);
      }
    } else {
      const state = toObject(interactives, (each) => {
        return [`textList_${each.chartId}`, each.objects];
      });
      this.setState(state);
    }
  }
  handleChoosePosition(text, moreProps) {
    this.componentWillUnmount();
    const { id: chartId } = moreProps.chartConfig;

    this.setState({
      [`textList_${chartId}`]: [...this.state[`textList_${chartId}`], text],
      showModal: true,
      text: text.text,
      chartId,
    });
  }
  handleTextChange(text, chartId) {
    const textList = this.state[`textList_${chartId}`];
    const allButLast = textList.slice(0, textList.length - 1);

    const lastText = {
      ...last(textList),
      text,
    };

    this.setState({
      [`textList_${chartId}`]: [...allButLast, lastText],
      showModal: false,
      enableInteractiveObject: false,
    });
    this.componentDidMount();
  }
  handleDialogClose() {
    this.setState({
      showModal: false,
    });
    this.componentDidMount();
  }

  componentDidMount() {
    document.addEventListener("keyup", this.onKeyPress);
  }
  componentWillUnmount() {
    document.removeEventListener("keyup", this.onKeyPress);
  }
  onDrawComplete(textList, moreProps) {
    // this gets called on
    // 1. draw complete of drawing object
    // 2. drag complete of drawing object
    const { id: chartId } = moreProps.chartConfig;

    this.setState({
      enableInteractiveObject: false,
      [`textList_${chartId}`]: textList,
    });
  }
  onKeyPress(e) {
    const keyCode = e.which;
    console.log(keyCode);
    switch (keyCode) {
      case 46: {
        // DEL
        this.setState({
          textList_1: this.state.textList_1.filter((d) => !d.selected),
          textList_3: this.state.textList_3.filter((d) => !d.selected),
        });
        break;
      }
      case 27: {
        // ESC
        this.node.terminate();
        this.canvasNode.cancelDrag();
        this.setState({
          enableInteractiveObject: false,
        });
        break;
      }
      case 68: // D - Draw drawing object
      case 69: {
        // E - Enable drawing object
        this.setState({
          enableInteractiveObject: true,
        });
        break;
      }
    }
  }
  render() {
    const macdCalculator = macd()
      .options({
        fast: 12,
        slow: 26,
        signal: 9,
      })
      .merge((d, c) => {
        d.macd = c;
      })
      .accessor((d) => d.macd);

    const { type, data: initialData, width, ratio } = this.props;
    const { showModal, text, search } = this.state;

    const ema50 = ema()
      .id(2)
      .options({ windowSize: 50 })
      .merge((d, vega) => {
        d.ema50 = vega;
      })
      .accessor((d) => d.ema50);

    const calculatedData = macdCalculator(initialData);
    const xScaleProvider = discontinuousTimeScaleProvider.inputDateAccessor(
      (d) => d.date
    );

    const { data, xScale, xAccessor, displayXAccessor } =
      xScaleProvider(calculatedData);

    const start = xAccessor(last(data));
    const end = xAccessor(data[Math.max(0, data.length - 150)]);
    const xExtents = [start, end];
    const calculatedData1 = ema50(data);
    return (
      <div>
        <Card
          className={"border border-dark .bg-light text-black my-custom-class2"}
        >
          <Card.Header>
            <div style={{ float: "left" }}>
              <FontAwesomeIcon icon={faList} /> Trade List
            </div>
            <div style={{ float: "right" }}>
              <InputGroup size="sm">
                <Form.Label>Expiry</Form.Label>
                <Form.Control
                  type="text"
                  name="expiry"
                  onChange={this.handleInputChange} 
                  value={this.state.expiry}
                />
                <Form.Label>Option Symbol Name</Form.Label>
                <Form.Control
                  type="text"
                  name="optionName"
                  onChange={this.handleInputChange} 
                  value={this.state.optionName}
                />
                <Form.Control
                  required
                  as="select"
                  custom
                  name="search"
                  value={search}
                   onChange={this.searchChange}
                  className={"info-border .bg-light text-black"}
                >
                  {this.state.symbols.map((symbol) => (
                    <option key={symbol.value} value={symbol.value}>
                      {symbol.display}
                    </option>
                  ))}
                </Form.Control>
                <InputGroup.Append>
                  <Button
                    size="sm"
                    variant="outline-info"
                    type="button"
                    onClick={() => {
                      this.searchData();
                    }}
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </Button>
                </InputGroup.Append>
              </InputGroup>
            </div>
          </Card.Header>
        </Card>
        <ChartCanvas
          ref={this.saveCanvasNode}
          height={720}
          width={width}
          ratio={ratio}
          margin={{ left: 70, right: 70, top: 20, bottom: 30 }}
          type={type}
          seriesName="MSFT"
          data={data}
          xScale={xScale}
          xAccessor={xAccessor}
          displayXAccessor={displayXAccessor}
          xExtents={xExtents}
        >
          <Chart
            id={1}
            height={300}
            yExtents={[(d) => [d.high, d.low]]}
            padding={{ top: 10, bottom: 20 }}
          >
            <XAxis
              axisAt="bottom"
              orient="bottom"
              showTicks={false}
              outerTickSize={0}
            />
            <YAxis axisAt="right" orient="right" ticks={5} />
            <MouseCoordinateY
              at="right"
              orient="right"
              displayFormat={format(".2f")}
            />

            <CandlestickSeries />

            <EdgeIndicator
              itemType="last"
              orient="right"
              edgeAt="right"
              yAccessor={(d) => d.close}
              fill={(d) => (d.close > d.open ? "#6BA583" : "#FF0000")}
            />

            <OHLCTooltip origin={[-40, 0]} />
          </Chart>
          <Chart
            id={2}
            height={150}
            yExtents={[(d) => [d.vega], ema50.accessor()]}
            yExtents={[(d) => d.ema50]}
            origin={(w, h) => [0, h - 300]}
          >
            <YAxis
              axisAt="left"
              orient="left"
              ticks={5}
              tickFormat={format(".2s")}
            />
            <XAxis axisAt="bottom" orient="bottom" />
            <YAxis axisAt="right" orient="right" ticks={2} />

            <MouseCoordinateX
              at="bottom"
              orient="bottom"
              displayFormat={timeFormat("%Y-%m-%d")}
            />
            <MouseCoordinateY
              at="right"
              orient="right"
              displayFormat={format(".2f")}
            />

            <LineSeries yAccessor={(d) => d.vega} />
            <LineSeries yAccessor={(d) => d.ema50} />
            <LineSeries yAccessor={(d) => d.vega_o} />
          </Chart>
          <CrossHairCursor />
        </ChartCanvas>
        <Dialog
          showModal={showModal}
          text={text}
          chartId={this.state.chartId}
          onClose={this.handleDialogClose}
          onSave={this.handleTextChange}
        />
      </div>
    );
  }
}

CandleStickChartWithText.propTypes = {
  data: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired,
  ratio: PropTypes.number.isRequired,
  type: PropTypes.oneOf(["svg", "hybrid"]).isRequired,
};

CandleStickChartWithText.defaultProps = {
  type: "svg",
};

const CandleStickChart = fitWidth(CandleStickChartWithText);

export default CandleStickChart;
